import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as extract from 'extractFromState';
import CWProduct from '../CWProduct/CWProduct';

const CWSelectedPreviousRecommendation = (props) => {
  const getProductPrice = () => {
    return props.selectedRecommendation.price && Math.floor(props.selectedRecommendation.price).toFixed(0);
  };

  return (
    props.selectedRecommendation && (
      <>
        <CWProduct
          headerText={'This is a previously recommended product'}
          image={props.selectedRecommendation.image}
          productLink={props.selectedRecommendation.productLink}
          description={props.selectedRecommendation.description}
          price={getProductPrice()}
          title={props.selectedRecommendation.title}
        />
      </>
    )
  );
};

CWSelectedPreviousRecommendation.propTypes = {
  selectedRecommendation: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  selectedRecommendation: extract.extractCommerceWizardSelectedPreviousRecommendation(state),
});

export default connect(mapStateToProps)(CWSelectedPreviousRecommendation);
